// Minimal YouTube URL → embed URL helper. Returns null when the URL isn't
// something we recognise, so callers can just render nothing.
export const toYouTubeEmbed = (raw) => {
  if (!raw) return null;
  const url = String(raw).trim();
  if (!url) return null;
  // Already an embed URL — pass through
  if (/^https?:\/\/(www\.)?youtube\.com\/embed\//i.test(url)) return url;
  const patterns = [
    /(?:youtu\.be\/)([\w-]{11})/i,               // youtu.be/<id>
    /(?:youtube\.com\/watch\?[^#]*\bv=)([\w-]{11})/i, // watch?v=<id>
    /(?:youtube\.com\/shorts\/)([\w-]{11})/i,    // shorts/<id>
    /(?:youtube\.com\/live\/)([\w-]{11})/i,      // live/<id>
  ];
  for (const p of patterns) {
    const m = url.match(p);
    if (m) return `https://www.youtube.com/embed/${m[1]}?rel=0`;
  }
  return null;
};
